import Vue from 'vue'
import { mapState } from 'vuex'

const contentSlideTypes = [
  'freestyle',
  'bulletPoints',
  'qrcode',
  'image',
  'youtube',
  'document',
  'googleSlides',
  'spinnerWheel',
  'ideas',
]

export default (component) => Vue.component('FooterContainer', {
  computed: {
    ...mapState({
      slide: (state) => state.slide,
      presentation: (state) => state.presentation,
      activeTabView: (state) => state.activeTabView,
    }),
    isCtaShowing() {
      if (!this.presentation.id || !this.slide.id) return false
      if (this.presentation.user && this.presentation.user.isGuest) return false

      // don't show if current slide is not last slide
      if (this.slide.id !== this.presentation.lastSlide) return false

      if (this.activeTabView === 'lookback') return false

      if (this.slide.isEndSlide) return true
      if (contentSlideTypes.includes(this.slide.type)) return true

      if (this.slide.type === 'question') return true
      if (this.slide.type === 'leaderboard') return true
      if (this.slide.type === 'openEnded' && this.slide.openEndedMultipleOption) return true

      if (this.slide.type === 'wordCloud' && this.slide.openEndedMultipleOption) return true

      return false
    },
    canDisplayFooter() {
      return this.presentation && this.presentation.id && this.presentation.planType !== 'white-label'
    },
  },
  render(createElement) {
    // do not show any footer for white label users
    if (!this.canDisplayFooter) return null

    return createElement(component, {
      props: {
        isCtaShowing: this.isCtaShowing,
      },
    })
  },
})
